export function getParentPathBeforeLastBracket(path: string) {
  const parts = path.split(".");
  for (let i = parts.length - 1; i >= 0; i--) {
    if (/\[\d+\]/.test(parts[i])) {
      return parts.slice(0, i).join(".");
    }
  }
  return null;
}
